import * as React from 'react';
import { SvgIcon, color } from '@kis-technologies/kis-ui';
import { SystemsPaginationButton, useStyles } from '../styled';
import { PaginationProps } from '../types';

export const SystemsPagination = (props: PaginationProps) => {
  const { page, pages, onPageChange } = props;
  const classes = useStyles();

  if (pages <= 1) return null;

  return (
    <>
      {page !== 1 && (
        <SystemsPaginationButton
          position="left"
          onClick={() => onPageChange(page - 1)}
          data-testid="systems-pagination-prev"
          className={classes.systemPaginationPrev}
        >
          <SvgIcon name="chevron_left" color={color.WHITE} size={51} />
        </SystemsPaginationButton>
      )}
      {page !== pages && (
        <SystemsPaginationButton
          position="right"
          onClick={() => onPageChange(page + 1)}
          data-testid="systems-pagination-next"
          className={classes.systemPaginationNext}
        >
          <SvgIcon name="chevron_right" color={color.WHITE} size={51} />
        </SystemsPaginationButton>
      )}
    </>
  );
};
